module.exports = __webpack_public_path__ + "static/img/title.bd7042f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardPH/img/title.png
// module id = YT0V
// module chunks = 1